import BaseAPI from '@/apis/base/baseApi';

export default class BAApi extends BaseAPI {
  apiName = 'BA';
}
